var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _ellipse, _g17, _path, _g18, _g19, _line, _g20, _g21, _rect, _g22, _path2, _line2, _ellipse2, _g23, _g24, _line3, _rect2, _rect3, _rect4, _g25, _rect5, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _rect6, _rect7, _rect8, _path3, _path4, _line4, _line5, _ellipse3, _line6, _line7, _ellipse4, _ellipse5, _g33, _line8, _line9, _g34, _line10, _g35, _line11, _g36, _g37, _g38, _g39, _path5, _path6, _path7, _line12, _line13, _g40, _path8, _rect9, _rect10, _g41, _g42, _path9, _g43, _rect11, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _rect12, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _rect13, _rect14, _g77, _g78, _line14, _g79, _rect15, _line15, _g80, _path10, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _line16, _g109, _path11, _rect16, _g110, _path12, _path13, _rect17, _rect18, _path14, _g111, _rect19, _rect20, _rect21, _rect22, _g112, _g113, _g114, _g115, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownwordSkyline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1235 239.3409961685824",
    style: {
      maxHeight: 500
    },
    width: 1235,
    height: 239.3409961685824,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2022_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    shapeRendering: "crispEdges",
    strokeWidth: 2,
    strokeOpacity: 0.5,
    stroke: "black",
    ry: 69.5,
    rx: 73,
    cy: 168.5,
    cx: 1185
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2022_2)"
  }, /*#__PURE__*/React.createElement("line", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 169.865,
    x2: 1112.71,
    y1: 169.865,
    x1: 1257.71
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2323",
    height: 106,
    width: 38,
    y: 133,
    x: 1080
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 4,
    width: 18,
    y: 208,
    x: 1091
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 4,
    width: 18,
    y: 216,
    x: 1091
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 18,
    y: 224,
    x: 1091
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 18,
    y: 231,
    x: 1091
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 18,
    y: 224,
    x: 1091
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 18,
    y: 240,
    x: 1091
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 4,
    width: 18,
    y: 153,
    x: 1091
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 4,
    width: 18,
    y: 161,
    x: 1091
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 4,
    width: 18,
    y: 169,
    x: 1091
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 18,
    y: 178,
    x: 1091
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M1091 186H1109V189H1091V186Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M1091 194H1109V198H1091V194Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M1091 201H1109V205H1091V201Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C1717",
    ry: 5.5,
    rx: 6.5,
    cy: 170.5,
    cx: 1186.5
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#342A2A",
    height: 61,
    width: 47,
    y: 179,
    x: 1112
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#413232",
    d: "M1127 179C1135.38 128.289 1141.82 157.871 1144 179H1127Z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#483333",
    height: 24,
    width: 14,
    y: 187,
    x: 861
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#524B4B",
    height: 8,
    width: 18,
    y: 221,
    x: 788
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#2F1E1E",
    y2: 234.972,
    x2: 1025.5,
    y1: 181.972,
    x1: 1024.5
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2323",
    height: 25,
    width: 24,
    y: 202,
    x: 622
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#322828",
    height: 37,
    width: 12,
    y: 87,
    x: 670
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1E1B1B",
    height: 120,
    width: 10,
    y: 120,
    x: 20
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#330909",
    height: 25,
    width: 43,
    y: 214,
    x: 231
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    d: "M106 235V203"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "black",
    y2: 204,
    x2: 112.5,
    y1: 236,
    x1: 112.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6F2828",
    ry: 22.5,
    rx: 23.5,
    cy: 211.5,
    cx: 109.5
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#201919",
    height: 8,
    width: 17,
    y: 232,
    x: 101
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2323",
    height: 24,
    width: 14,
    y: 122,
    x: 204
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 5,
    stroke: "#241A1A",
    y2: 136,
    x2: 225.5,
    y1: 146,
    x1: 225.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#290606",
    height: 148,
    width: 19,
    y: 92,
    x: 143
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1E1B1B",
    height: 175,
    width: 25,
    y: 65,
    x: 271
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#360909",
    height: 105,
    width: 13,
    y: 134,
    x: 168
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#392929",
    height: 94,
    width: 27,
    y: 146,
    x: 204
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1E1B1B",
    height: 167,
    width: 29,
    y: 73,
    x: 828
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 125,
    x: 833
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 132,
    x: 833
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 138,
    x: 833
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 144,
    x: 833
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 138,
    x: 833
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 151,
    x: 833
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#330909",
    height: 40,
    width: 23,
    y: 199,
    x: 1060
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#312D2D",
    height: 142,
    width: 27,
    y: 98,
    x: 939
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#332E2E",
    height: 29,
    width: 23,
    y: 211,
    x: 857
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#413232",
    height: 51,
    width: 13,
    y: 189,
    x: 921
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#684747",
    d: "M928 175L935.794 189.25H920.206L928 175Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#340A0A",
    d: "M899.5 113L920.718 240.5H878.282L899.5 113Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 4,
    stroke: "black",
    y2: 237.532,
    x2: 991.928,
    y1: 179.532,
    x1: 1007.93
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 4,
    stroke: "black",
    y2: 239.386,
    x2: 1058.9,
    y1: 177.386,
    x1: 1038.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#231F1F",
    ry: 28,
    rx: 31.5,
    cy: 155,
    cx: 1024.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "black",
    y2: 2.91609,
    x2: 1021.5,
    y1: 127.854,
    x1: 1014.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "black",
    y2: 127.899,
    x2: 1032.5,
    y1: 2.89869,
    x1: 1024.04
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#211212",
    ry: 2.5,
    rx: 6,
    cy: 2.5,
    cx: 1023
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C1717",
    ry: 14,
    rx: 12.5,
    cy: 39,
    cx: 1022.5
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#201919",
    height: 13,
    width: 93,
    y: 227,
    x: 952
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#1D1515",
    y2: 188.5,
    x2: 1044,
    y1: 188.5,
    x1: 1004
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#1D1515",
    y2: 115.5,
    x2: 1016.72,
    y1: 115.5,
    x1: 1031.28
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2323",
    height: 25,
    width: 24,
    y: 108,
    x: 1090
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 9,
    stroke: "#241A1A",
    y2: 98,
    x2: 1102.5,
    y1: 108,
    x1: 1102.5
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_2022_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "black",
    ry: 36.5,
    rx: 35.5,
    cy: 169.5,
    cx: 1186.5
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 99,
    x2: 1188.5,
    y1: 239,
    x1: 1188.5
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_2022_2)"
  }, /*#__PURE__*/React.createElement("line", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 133.975,
    x2: 1251.41,
    y1: 206.747,
    x1: 1125.37
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_2022_2)"
  }, /*#__PURE__*/React.createElement("line", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 133.433,
    x2: 1124.13,
    y1: 203.433,
    x1: 1245.37
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_2022_2)"
  }, /*#__PURE__*/React.createElement("line", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 107.628,
    x2: 1152.57,
    y1: 228.872,
    x1: 1222.57
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_2022_2)"
  }, /*#__PURE__*/React.createElement("line", {
    shapeRendering: "crispEdges",
    strokeOpacity: 0.5,
    stroke: "#231F1F",
    y2: 109.128,
    x2: 1223.57,
    y1: 230.372,
    x1: 1153.57
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#211D1D",
    d: "M30 124C86.9113 198.588 62.0863 237.582 30 240V124Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1919",
    d: "M30 124C86.9113 198.588 62.0863 237.582 30 240V124Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    d: "M30 124C86.9113 198.588 62.0863 237.582 30 240V124Z"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    stroke: "#1C1818",
    y2: 227.5,
    x2: 124,
    y1: 227.5,
    x1: 94
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    stroke: "#211F1F",
    y2: 240,
    x2: 121.5,
    y1: 226,
    x1: 121.5
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#201919",
    height: 5,
    width: 75,
    y: 234,
    x: 4
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3D3D",
    d: "M253 196L267.722 211.75H238.278L253 196Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#312D2D",
    height: 160,
    width: 15,
    y: 80,
    x: 276
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#533535",
    height: 112,
    width: 18,
    y: 127,
    x: 327
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#524B4B",
    height: 8,
    width: 18,
    y: 227,
    x: 132
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#544242",
    height: 86,
    width: 56,
    y: 154,
    x: 346
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#413232",
    d: "M349 154C373.15 108.723 391.729 135.134 398 154H349Z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#373434",
    height: 12,
    width: 169,
    y: 229,
    x: 294
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#332E2E",
    height: 22,
    width: 17,
    y: 218,
    x: 218
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 79,
    x: 833
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 86,
    x: 833
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 92,
    x: 833
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 19,
    y: 99,
    x: 833
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M833 106H852V109H833V106Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M833 113H852V116H833V113Z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M833 119H852V122H833V119Z"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#574E4E",
    height: 6,
    width: 51,
    y: 234,
    x: 123
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 12,
    y: 201,
    x: 34
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 206,
    x: 34
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 210,
    x: 34
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 214,
    x: 34
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 210,
    x: 34
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 220,
    x: 34
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 170,
    x: 34
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 1,
    width: 12,
    y: 175,
    x: 34
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 178,
    x: 34
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 12,
    y: 182,
    x: 34
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M34 188H46V190H34V188Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M34 193H46V195H34V193Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M34 197H46V199H34V197Z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 1,
    width: 32,
    y: 205,
    x: 358
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 150,
    y: 233,
    x: 318
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 214,
    x: 356
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 218,
    x: 356
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 211,
    x: 358
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 32,
    y: 222,
    x: 358
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 173,
    x: 358
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 178,
    x: 358
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 182,
    x: 358
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 186,
    x: 358
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M358 191H390V193H358V191Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M358 196H390V198H358V196Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M358 200H390V203H358V200Z"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#565456",
    height: 115,
    width: 9,
    y: 125,
    x: 1148
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#302222",
    height: 7,
    width: 37,
    y: 233,
    x: 909
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#400707",
    height: 47,
    width: 35,
    y: 193,
    x: 173
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#322828",
    height: 37,
    width: 12,
    y: 87,
    x: 648
  }))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 5,
    stroke: "#291717",
    y2: 57,
    x2: 676.5,
    y1: 87,
    x1: 676.5
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2121",
    height: 114,
    width: 39,
    y: 124,
    x: 646
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1E1B1B",
    height: 92,
    width: 12,
    y: 148,
    x: 161
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 5,
    stroke: "#291717",
    y2: 57,
    x2: 654.5,
    y1: 87,
    x1: 654.5
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#342A2A",
    height: 76,
    width: 41,
    y: 162,
    x: 545
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#413232",
    d: "M705 242C716.829 107.979 725.929 186.158 729 242H705Z"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 1,
    width: 32,
    y: 287,
    x: 567
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 296,
    x: 565
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 300,
    x: 565
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 293,
    x: 567
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 32,
    y: 304,
    x: 567
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 256,
    x: 567
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 261,
    x: 567
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 265,
    x: 567
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 269,
    x: 567
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M567 274H599V276H567V274Z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M567 278H599V280H567V278Z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M567 282H599V285H567V282Z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#531111",
    height: 82,
    width: 43,
    y: 156,
    x: 556
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#320707",
    height: 12,
    width: 166,
    y: 228,
    x: 520
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 1,
    width: 32,
    y: 168,
    x: 563
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 148,
    y: 231,
    x: 532
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 212,
    x: 562
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 216,
    x: 562
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 32,
    y: 206,
    x: 561
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 3,
    width: 32,
    y: 220,
    x: 562
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 25,
    y: 174,
    x: 565
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 25,
    y: 179,
    x: 565
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 1,
    width: 25,
    y: 188,
    x: 565
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A3C3C",
    height: 2,
    width: 25,
    y: 185,
    x: 565
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M562 167H594V169H562V167Z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M563 194H595V196H563V194Z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_f_2022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A3C3C",
    d: "M562 198H594V201H562V198Z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#241212",
    height: 19,
    width: 41,
    y: 221,
    x: 504
  }))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 9,
    stroke: "#552222",
    y2: 192,
    x2: 641.5,
    y1: 202,
    x1: 641.5
  })), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2323",
    height: 27,
    width: 38,
    y: 214,
    x: 467
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3D3D",
    d: "M491 194L502.258 213.5H479.742L491 194Z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#332E2E",
    height: 12,
    width: 33,
    y: 229,
    x: 487
  })), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#270404",
    height: 18,
    width: 35,
    y: 223,
    x: 436
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3D3D",
    d: "M478 194L489.258 213.5H466.742L478 194Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#413232",
    d: "M733 242C744.829 107.979 753.929 186.158 757 242H733Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#524A4A",
    height: 1,
    width: 50,
    y: 199,
    x: 707
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#524A4A",
    height: 2,
    width: 58,
    y: 193,
    x: 703
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#453A3A",
    d: "M691 233C730.429 222.133 760.762 228.472 771 233H691Z"
  })), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_d_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#524B4B",
    height: 8,
    width: 18,
    y: 221,
    x: 808
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#491111",
    height: 13,
    width: 52,
    y: 228,
    x: 780
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#3D3131",
    height: 157,
    width: 19,
    y: 83,
    x: 1157
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#574E4E",
    height: 142,
    width: 8,
    y: 98,
    x: 1176
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#230909",
    height: 5,
    width: 40,
    y: 227,
    x: 1230
  })), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7A4C4C",
    height: 3,
    width: 13,
    y: 154,
    x: 997
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7A4C4C",
    height: 3,
    width: 13,
    y: 154,
    x: 1018
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7A4C4C",
    height: 3,
    width: 13,
    y: 154,
    x: 1039
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_f_2022_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7A4C4C",
    height: 2,
    width: 10,
    y: 36,
    x: 1018
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 149,
    width: 156,
    y: 98,
    x: 1107,
    id: "filter0_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 153,
    y: 169.365,
    x: 1108.71,
    id: "filter1_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 114,
    width: 46,
    y: 133,
    x: 1076,
    id: "filter2_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 204,
    x: 1087,
    id: "filter3_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 212,
    x: 1087,
    id: "filter4_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 220,
    x: 1087,
    id: "filter5_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 227,
    x: 1087,
    id: "filter6_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 220,
    x: 1087,
    id: "filter7_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 236,
    x: 1087,
    id: "filter8_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 149,
    x: 1087,
    id: "filter9_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 157,
    x: 1087,
    id: "filter10_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 165,
    x: 1087,
    id: "filter11_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 174,
    x: 1087,
    id: "filter12_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 26,
    y: 182,
    x: 1087,
    id: "filter13_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 190,
    x: 1087,
    id: "filter14_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 26,
    y: 197,
    x: 1087,
    id: "filter15_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 69,
    width: 55,
    y: 179,
    x: 1108,
    id: "filter16_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 32,
    width: 22,
    y: 187,
    x: 857,
    id: "filter17_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 16,
    width: 26,
    y: 221,
    x: 784,
    id: "filter18_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 33,
    width: 32,
    y: 202,
    x: 618,
    id: "filter19_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 45,
    width: 20,
    y: 87,
    x: 666,
    id: "filter20_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 33,
    width: 51,
    y: 214,
    x: 227,
    id: "filter21_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 16,
    width: 25,
    y: 232,
    x: 97,
    id: "filter22_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 32,
    width: 22,
    y: 122,
    x: 200,
    id: "filter23_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 102,
    width: 35,
    y: 146,
    x: 200,
    id: "filter24_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 121,
    x: 829,
    id: "filter25_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 128,
    x: 829,
    id: "filter26_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 134,
    x: 829,
    id: "filter27_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 140,
    x: 829,
    id: "filter28_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 134,
    x: 829,
    id: "filter29_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 147,
    x: 829,
    id: "filter30_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 48,
    width: 31,
    y: 199,
    x: 1056,
    id: "filter31_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21,
    width: 101,
    y: 227,
    x: 948,
    id: "filter32_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 33,
    width: 32,
    y: 108,
    x: 1086,
    id: "filter33_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 82,
    width: 80,
    y: 132.5,
    x: 1146.5,
    id: "filter34_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 81.6379,
    width: 134.545,
    y: 133.542,
    x: 1121.12,
    id: "filter35_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 78.866,
    width: 129.744,
    y: 133,
    x: 1119.88,
    id: "filter36_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 129.744,
    width: 78.866,
    y: 107.378,
    x: 1148.13,
    id: "filter37_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 129.744,
    width: 78.866,
    y: 108.878,
    x: 1149.13,
    id: "filter38_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 13,
    width: 83,
    y: 234,
    x: 0,
    id: "filter39_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 16,
    width: 26,
    y: 227,
    x: 128,
    id: "filter40_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 94,
    width: 64,
    y: 154,
    x: 342,
    id: "filter41_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 20,
    width: 177,
    y: 229,
    x: 290,
    id: "filter42_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 75,
    x: 829,
    id: "filter43_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 82,
    x: 829,
    id: "filter44_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 88,
    x: 829,
    id: "filter45_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 95,
    x: 829,
    id: "filter46_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 102,
    x: 829,
    id: "filter47_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 109,
    x: 829,
    id: "filter48_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 27,
    y: 115,
    x: 829,
    id: "filter49_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 20,
    y: 197,
    x: 30,
    id: "filter50_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 202,
    x: 30,
    id: "filter51_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 206,
    x: 30,
    id: "filter52_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 210,
    x: 30,
    id: "filter53_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 206,
    x: 30,
    id: "filter54_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 216,
    x: 30,
    id: "filter55_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 166,
    x: 30,
    id: "filter56_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 20,
    y: 171,
    x: 30,
    id: "filter57_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 174,
    x: 30,
    id: "filter58_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 178,
    x: 30,
    id: "filter59_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 184,
    x: 30,
    id: "filter60_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 189,
    x: 30,
    id: "filter61_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 20,
    y: 193,
    x: 30,
    id: "filter62_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 40,
    y: 201,
    x: 354,
    id: "filter63_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 158,
    y: 229,
    x: 314,
    id: "filter64_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 210,
    x: 352,
    id: "filter65_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 214,
    x: 352,
    id: "filter66_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 207,
    x: 354,
    id: "filter67_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 218,
    x: 354,
    id: "filter68_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 169,
    x: 354,
    id: "filter69_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 174,
    x: 354,
    id: "filter70_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 178,
    x: 354,
    id: "filter71_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 182,
    x: 354,
    id: "filter72_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 187,
    x: 354,
    id: "filter73_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 192,
    x: 354,
    id: "filter74_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 196,
    x: 354,
    id: "filter75_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 55,
    width: 43,
    y: 193,
    x: 169,
    id: "filter76_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 45,
    width: 20,
    y: 87,
    x: 644,
    id: "filter77_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 122,
    width: 47,
    y: 124,
    x: 642,
    id: "filter78_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 84,
    width: 49,
    y: 162,
    x: 541,
    id: "filter79_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 40,
    y: 283,
    x: 563,
    id: "filter80_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 292,
    x: 561,
    id: "filter81_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 296,
    x: 561,
    id: "filter82_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 289,
    x: 563,
    id: "filter83_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 300,
    x: 563,
    id: "filter84_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 252,
    x: 563,
    id: "filter85_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 257,
    x: 563,
    id: "filter86_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 261,
    x: 563,
    id: "filter87_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 265,
    x: 563,
    id: "filter88_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 270,
    x: 563,
    id: "filter89_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 274,
    x: 563,
    id: "filter90_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 278,
    x: 563,
    id: "filter91_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 90,
    width: 51,
    y: 156,
    x: 552,
    id: "filter92_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 20,
    width: 174,
    y: 228,
    x: 516,
    id: "filter93_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 40,
    y: 164,
    x: 559,
    id: "filter94_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 156,
    y: 227,
    x: 528,
    id: "filter95_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 208,
    x: 558,
    id: "filter96_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 212,
    x: 558,
    id: "filter97_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 202,
    x: 557,
    id: "filter98_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 216,
    x: 558,
    id: "filter99_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 33,
    y: 170,
    x: 561,
    id: "filter100_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 33,
    y: 175,
    x: 561,
    id: "filter101_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 9,
    width: 33,
    y: 184,
    x: 561,
    id: "filter102_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 33,
    y: 181,
    x: 561,
    id: "filter103_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 163,
    x: 558,
    id: "filter104_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 40,
    y: 190,
    x: 559,
    id: "filter105_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 40,
    y: 194,
    x: 558,
    id: "filter106_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 27,
    width: 49,
    y: 221,
    x: 500,
    id: "filter107_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 35,
    width: 46,
    y: 214,
    x: 463,
    id: "filter108_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 26,
    width: 43,
    y: 223,
    x: 432,
    id: "filter109_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 16,
    width: 26,
    y: 221,
    x: 804,
    id: "filter110_d_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2022_2",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2022_2",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 21,
    y: 150,
    x: 993,
    id: "filter111_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 21,
    y: 150,
    x: 1014,
    id: "filter112_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 11,
    width: 21,
    y: 150,
    x: 1035,
    id: "filter113_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10,
    width: 18,
    y: 32,
    x: 1014,
    id: "filter114_f_2022_2"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "BackgroundImageFix",
    in: "SourceGraphic",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2022_2",
    stdDeviation: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwordSkyline);
export default __webpack_public_path__ + "static/media/downword-skyline.1056bfea02600951052f8336387df877.svg";
export { ForwardRef as ReactComponent };